import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarReachedModule } from 'ngx-scrollbar/reached-event';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import { InfiniteScrollModule } from 'presentation/common/directive/infinite-scroll/infinite-scroll.module';
import { PipeModule } from 'presentation/common/pipe/pipe.module';
import { CoacheeProfileDocumentsModule } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.module';
import { CoacheeProfileInformationComponent } from 'presentation/page/profile/coachee-profile/coachee-profile-information/coachee-profile-information.component';
import { CoacheeProfileInformationModule } from 'presentation/page/profile/coachee-profile/coachee-profile-information/coachee-profile-information.module';
import { CoacheeProfileComponent } from 'presentation/page/profile/coachee-profile/coachee-profile.component';

import { AppSharedModule } from '../../../../app-shared.module';
import { CoacheeProfileMeetingsFilterComponent } from './coachee-profile-meetings/coachee-profile-meetings-filter/coachee-profile-meetings-filter.component';
import { CoacheeProfileMeetingsHeaderComponent } from './coachee-profile-meetings/coachee-profile-meetings-header/coachee-profile-meetings-header.component';
import { CoacheeProfileMeetingsMeetingComponent } from './coachee-profile-meetings/coachee-profile-meetings-meeting/coachee-profile-meetings-meeting.component';
import { CoacheeProfileMeetingsComponent } from './coachee-profile-meetings/coachee-profile-meetings.component';
import { CoacheeProfileNotesFilterComponent } from './coachee-profile-notes/coachee-profile-notes-filter/coachee-profile-notes-filter.component';
import { CoacheeProfileNotesHeaderComponent } from './coachee-profile-notes/coachee-profile-notes-header/coachee-profile-notes-header.component';
import { CoacheeProfileNotesNoteComponent } from './coachee-profile-notes/coachee-profile-notes-note/coachee-profile-notes-note.component';
import { CoacheeProfileNotesComponent } from './coachee-profile-notes/coachee-profile-notes.component';

@NgModule({
	declarations: [
		CoacheeProfileComponent,
		CoacheeProfileNotesComponent,
		CoacheeProfileMeetingsComponent,
		CoacheeProfileNotesNoteComponent,
		CoacheeProfileNotesHeaderComponent,
		CoacheeProfileNotesFilterComponent,
		CoacheeProfileMeetingsMeetingComponent,
		CoacheeProfileMeetingsHeaderComponent,
		CoacheeProfileMeetingsFilterComponent,
	],
	imports: [
		CommonModule,
		TranslateModule,
		PipeModule,
		CoacheeProfileDocumentsModule,
		CoacheeProfileInformationModule,
		TabViewModule,
		NgScrollbarReachedModule,
		AppSharedModule,
		InfiniteScrollModule,
	],
	exports: [CoacheeProfileComponent],
	providers: [],
})
export class CoacheeProfileModule {}
